import { useEffect, useState } from "react";
import { Disclosure, Transition } from "@headlessui/react";
import styles from "./index.module.css";
import { NavLink, useLocation } from "react-router-dom";
import { TiArrowSortedDown } from "react-icons/ti";
import ApiClient from "../../../methods/api/apiClient";
import { FiUsers } from "react-icons/fi";
import {
  MdManageAccounts,
  MdOutlineChat,
  MdSpaceDashboard,
  MdStore,
} from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { MdListAlt } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { FaCar } from "react-icons/fa";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { MdPayments } from "react-icons/md";
import { MdSettings } from "react-icons/md";
import { FaMapLocationDot } from "react-icons/fa6";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { IoCodeSharp } from "react-icons/io5";
import { RiCalendar2Line } from "react-icons/ri";
import { SiSitepoint } from "react-icons/si";
import { MdAdminPanelSettings } from "react-icons/md";
import { FaClipboardUser } from "react-icons/fa6";
import { MdOutlineManageHistory } from "react-icons/md";
import {
  BsCardChecklist,
  BsFillFileEarmarkBarGraphFill,
  BsFillPersonVcardFill,
} from "react-icons/bs";

import environment from "../../../environment";
import { GrDocumentPerformance } from "react-icons/gr";
import { TbMoneybag, TbReport } from "react-icons/tb";
import { CgPerformance } from "react-icons/cg";
import { useTranslation } from "react-i18next";

const Html = ({ ListItemLink, tabclass, isAllow, route, isOpen, user }) => {
  const { t } = useTranslation();
  const [activeplan, setActiveplan] = useState();
  const role = user?.customerRole?.name === "Group Leader";
  const getactivePlan = () => {
    let filter = {};
    if (user?.subRole?.id == environment.SubRolePartner) {
      filter = { id: user.id || user?._id };
    } else {
      filter = {};
    }
    ApiClient.get("api/getMyPlan", filter).then((res) => {
      if (res.success) {
        setActiveplan(res?.data);
      }
    });
  };

  const location = useLocation();
  useEffect(() => {
    if (user?.customerRole?.name === "Group Leader") {
      getactivePlan();
    }
  }, []);

  const activecls = (tab) => {
    let url = window.location.href;
    let value = false;
    tab?.map((itm) => {
      if (url.includes(itm)) value = true;
    });
    return value;
  };

  const menus = [
    {
      // name: "Dashboard",
      name: `${t("dashboard")}`,
      icon: (
        <MdSpaceDashboard className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      activeIcon: (
        <MdSpaceDashboard className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      url: "/dashboard",
      key: "readDashboard",
    },

    // {
    //   name: "Location",
    //   icon: (
    //     <FaMapLocationDot className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
    //   ),
    //   activeIcon: (
    //     <FaMapLocationDot className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
    //   ),
    //   url: "/location",
    //   key: "readLocation",
    // },
    {
      // name: "Attendance Registration",
      name: `${t("attendanceRegistration")}`,
      icon: <BsCardChecklist className="text-[20px]" />,
      activeIcon: <BsCardChecklist className="text-[20px]" />,
      menu: [
        {
          // name: "Clock In/Out Screen",
          name: `${t("clockInOutScreen")}`,
          icon: <BsCardChecklist className="text-[20px]" />,
          url: "/checkin/checkout",
          key: "readClock",
        },
        {
          // name: "Attendance Sheet",
          name: `${t("attendance")}`,
          icon: <BsCardChecklist className="text-[20px]" />,
          url: "/attendance",
          key: "readAttendance",
        },
      ],
    },

    {
      // name: "Performance Management",
      name: `${t("performanceManagement")}`,
      icon: <CgPerformance className="text-[20px]" />,
      activeIcon: <CgPerformance className="text-[20px]" />,
      menu: [
        {
          // name: "Monthly Target",
          name: `${t("monthlyTargetMenu")}`,
          icon: <TbMoneybag className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <TbMoneybag className="w-[30px] h-[30px] p-[5px] text-white " />
          ),
          url: "/budget",
          key: "readbudget",
        },
        {
          // name: "Daily Target",
          name: `${t("dailyTarget")}`,
          icon: <TbMoneybag className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <TbMoneybag className="w-[30px] h-[30px] p-[5px] text-white " />
          ),
          url: "/daily/bug",
          key: "readdailyBudget",
        },
        {
          // name: "Daily Report",
          name: `${t("dailyReport")}`,
          icon: <TbReport className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <TbReport className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/dailyreport",
          key: "readdailyreport",
        },
        {
          // name: "Performance",
          name: `${t("performance")}`,
          icon: (
            <BsFillFileEarmarkBarGraphFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          activeIcon: (
            <BsFillFileEarmarkBarGraphFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          url: "/performance",
          key: "readperformance",
        },
      ],
    },
    {
      // name: "Shift Management",
      name: `${t("shiftManagement")}`,
      icon: <MdOutlineManageHistory className="text-[20px]" />,
      activeIcon: <MdOutlineManageHistory className="text-[20px]" />,
      menu: [
        // {
        //   name: "Shift Request Entry",
        //   icon: <BsCardChecklist className="text-[20px]" />,
        //   url: "/shift",
        //   key: "readShift",
        // },
        {
          // name: " Shift List",
          name: `${t("shiftManagement")}`,
          icon: <BsCardChecklist className="text-[20px]" />,
          url: "/shift",
          key: "readShift",
        },
        {
          // name: "Calendar View",
          name: `${t("calendarView")}`,
          icon: <BsCardChecklist className="text-[20px]" />,
          url: "/calendar",
          key: "readCalendar",
        },
      ],
    },

    {
      // name: "Master Management",
      name: `${t("masterManagement")}`,
      icon: <MdManageAccounts className="text-[20px]" />,
      activeIcon: <MdManageAccounts className="text-[20px]" />,
      menu: [
        {
          // name: "Store Management",
          name: `${t("storeManagement")}`,
          icon: (
            <MdStore className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          activeIcon: (
            <MdStore className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          url: "/store",
          key: "readstore",
        },
        {
          // name: "Manager Management",
          name: `${t("managermanage")}`,
          icon: (
            <FaClipboardUser className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          activeIcon: (
            <FaClipboardUser className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          url: "/manager",
          key: "readManager",
        },
        {
          // name: "Staff Management",
          name: `${t("staff")}`,
          icon: (
            <FaUsers className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          activeIcon: (
            <FaUsers className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          url: "/staff",
          key: "readStaff",
        },
        {
          // name: "Business Partners",
          name: `${t("businessPartners")}`,
          icon: (
            <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] " />
          ),
          activeIcon: (
            <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/business/partner",
          key: "readBusinessPartner",
        },
        {
          // name: "Admin",
          name: `${t("admin")}`,
          icon: (
            <MdAdminPanelSettings className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          activeIcon: (
            <MdAdminPanelSettings className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
          ),
          url: "/subadmin",
          key: "readsubadmin",
        },
      ],
    },

    {
      // name: "Messages",
      name: `${t("messages")}`,
      icon: <MdOutlineManageHistory className="text-[20px]" />,
      activeIcon: <MdOutlineManageHistory className="text-[20px]" />,
      menu: [
        {
          // name: "Chat",
          name: `${t("chat")}`,
          icon: <MdOutlineChat className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <MdOutlineChat className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/chats",
          key: "readchats",
        },
        {
          // name: "Bulletin Board",
          name: `${t("bulletinBoard")}`,
          icon: <MdOutlineChat className="w-[30px] h-[30px] p-[5px] " />,
          activeIcon: (
            <MdOutlineChat className="w-[30px] h-[30px] p-[5px] text-white" />
          ),
          url: "/bulletin/board",
          key: "readBulletin",
        },
      ],
    },
    // {
    //   name: "Supplier Management",
    //   icon: (
    //     <BsFillPersonVcardFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
    //   ),
    //   activeIcon: (
    //     <BsFillPersonVcardFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
    //   ),
    //   url: "/supplier",
    //   key: "readsupplier",
    // },
  ];

  return (
    <>
      <div
        className={`px-[12px] sidebar-padding ${isOpen && styles.sm_sidebar}`}
        component="siderbar"
      >
        <ul className="space-y-2 ">
          {menus.map((itm) => {
            return (
              <>
                {itm.icon ? (
                  <>
                    <li>
                      {itm.menu ? (
                        <>
                          {isAllow(
                            itm.menu.map((itm) => itm.key).toString()
                          ) ? (
                            <>
                              <Disclosure
                                as="div"
                                defaultOpen={activecls(
                                  itm.menu.map((itm) => itm.url)
                                )}
                              >
                                {({ open }) => (
                                  <>
                                    <tooltip placement="right" title={itm.name}>
                                      <Disclosure.Button className="w-full p-4 rounded-md flex items-center justify-between gap-[12px] transition-all duration-300 sidebar-drop">
                                        <span className="text-sm fow-full  rounded-md flex items-center justify-between gap-[12px] transition-all duration-300nt-normal text-[#5B6670] flex items-center gap-[12px] crm ">
                                          {!open ? (
                                            <>{itm?.icon}</>
                                          ) : (
                                            <>{itm?.activeIcon}</>
                                          )}
                                          <span className="text-inherit leading-none text-[#5B6670] sidebar_text whitespace-nowrap">
                                            {itm.name}
                                          </span>
                                        </span>
                                        <TiArrowSortedDown
                                          className={`${
                                            open ? "" : "-rotate-90 transform"
                                          } h-3 w-3 transition-all duration-500 arrow-icon`}
                                        />
                                      </Disclosure.Button>
                                    </tooltip>
                                    <Transition
                                      enter="transition duration-300 ease-in-out"
                                      enterFrom="transform scale-95 opacity-0"
                                      enterTo="transform scale-300 opacity-300"
                                      leave="transition duration-300 ease-in-out"
                                      leaveFrom="transform scale-300 opacity-300"
                                      leaveTo="transform scale-95 opacity-0"
                                    >
                                      <Disclosure.Panel className=" mt-[4px] ">
                                        <ul className="space-y-2">
                                          {itm.menu?.map((sitm) => {
                                            return (
                                              <>
                                                {isAllow(sitm.key) ? (
                                                  <li className="nested-li px-4">
                                                    {" "}
                                                    <NavLink
                                                      className={(isActive) =>
                                                        "p-4 rounded-md block text-sm font-normal text-[#333] cursor-pointer !no-underline transition-all " +
                                                        (location?.pathname.includes(
                                                          sitm.url
                                                        ) &&
                                                          " !text-[#3C73AA] !bg-[#4d899247]  !font-medium")
                                                      }
                                                      to={sitm.url}
                                                    >
                                                      <div className="flex items-center relative ">
                                                        <span className="w-[7px] h-[7px] bg-[#596b77] rounded-full block absolute -left-[4px]"></span>
                                                        <span
                                                          className="text-inherit leading-none nested-text ps-5"
                                                          title={sitm.name}
                                                        >
                                                          {sitm.name}
                                                        </span>
                                                      </div>
                                                    </NavLink>
                                                  </li>
                                                ) : null}
                                              </>
                                            );
                                          })}
                                        </ul>
                                      </Disclosure.Panel>
                                    </Transition>
                                  </>
                                )}
                              </Disclosure>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          {isAllow(itm.key) ? (
                            <>
                              <tooltip
                                placement="top"
                                color="#3730ff"
                                title={itm.name}
                              >
                                <NavLink
                                  to={itm.url}
                                  className={(isActive) =>
                                    "px-2 py-3 rounded-md flex items-center gap-[12px] text-sm font-normal text-[#5B6670] hover:!text-[#3C73AA] hover:bg-[#3C73AA]/20 !no-underline transition-all " +
                                    (location?.pathname.includes(itm.url) &&
                                      " !text-[#3C73AA] !bg-[#3C73AA]/20 !font-medium")
                                  }
                                >
                                  {!location?.pathname.includes(itm.url) ? (
                                    <>{itm.icon}</>
                                  ) : (
                                    <>{itm?.activeIcon}</>
                                  )}

                                  <span className="text-inherit leading-none sidebar_text">
                                    {itm.name}
                                  </span>
                                </NavLink>
                              </tooltip>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <h6
                        className={`${
                          isOpen ? "py-[12px] " : "p-[12px]  text-md"
                        } text-xs font-medium text-[#7E8B99] mt-[12px]`}
                      >
                        <span className=" sidebar_text text-center">
                          {" "}
                          {itm.name}{" "}
                        </span>
                      </h6>
                    </li>
                  </>
                )}
              </>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Html;
